import { TwitterAccessTokenResponse } from './../../auths-api/twitter-access-token';

export const mockTwitterAccessTokenResponse: TwitterAccessTokenResponse = {
  accessToken: 'xxx',
  accessTokenSecret: 'xxx',
};
